import addElementModalTemplate from '../../../views/seats/add-element-modal.tpl.html';
import rsvpDeposit from '../../../../../components/deposits/rsvps.json';

class DoBookingModalController {
    constructor(Contact,
                Rsvp,
                $scope,
                $rootScope,
                guestlist,
                seatplan,
                selectedObjects,
                $uibModalInstance,
                $uibModal,
                SweetAlert,
                currentGroup,
                bookingInformation,
                Contacts,
                $q,
                $http,
                blockedElements,
                Users,
                Deposit,
                $injector) {
        this.contactModel = Contact;
        this.rsvpModel = Rsvp;
        this.scope = $scope;
        this.rootScope = $rootScope;
        this.guestlist = guestlist;
        this.selected = selectedObjects;
        this.seatplan = seatplan;
        this.currentGroup = currentGroup;
        this.modalInstance = $uibModalInstance;
        this.modal = $uibModal;
        this.sweetAlert = SweetAlert;
        this.bookingInformation = bookingInformation;
        this.$q = $q;
        this.api = $http;
        this.blockedElements = blockedElements;
        this.user = Users;
        this.depositService = Deposit;
        this.injector = $injector;
        this.alert = $injector.get('Alert');
        this.translate = $injector.get('$translate');

        this.currentSelectedObject = this.selected.length > 0 ? this.selected[0] : null;
        this.rsvpDeposit = rsvpDeposit;
        this.loading = true;
        this.submitting = false;
        this.showAreaSelector = false;

        this.allowElementMultiSelection = _.get(this.user, 'state.company.settings.seatplans.enable_multiple_bookings_per_element')

        this.currentPax = 0;

        this.contactType = 1;
        this.contactsConfig = {
            store: Contacts.reset({
                listview: 'DoBookingModalListView',
                persist: false
            }),
            maxItems: 1,
            displayField: 'cnr_full_name_co'
        };

        this.rsvp = {
            guestlist_id: this.guestlist.id,
            seatplan_elements: {},
            status: 'invited',
            guestlist_combination_id: null,
            bookable_objects: {},
            pax_planned: 0,
            wants_shipping: _.get(this.user, 'state.company.settings.shipping.enable_shipping_on_rsvps_by_default'),
            single_invoice: false,
            group_vouchers: false,
            split_vouchers: false,
            migrate_to_new_year: false,
            custom_end_time: null,
            custom_start_time: null
        };
        this.guestlistConfig = {};
        this.currentAreaConfigs = [];
        this.currentMainTab = 'general';

        this.newContact = {
            'sex': 'various',
            'language': 'DE',
            'country': 'DE'
        };

        this.deposits = {
            rsvpStates: [],
            countries: {},
            languages: {},
            genders: {}
        };

        this.customTimeFieldStates = {
            custom_start_time: false,
            custom_end_time: false
        };

        this.contactSchema = {};
        this.rsvpStates = this.rsvpDeposit.states;
        this._setSettings();

        this._updateRsvpSeatplanElements();
        this._initWatchers();
        this.updateRsvpStates();

        this.$q.all([
            this._initContactSchema(),
            this._getGuestlistConfigForSeatplanElements(),
            this._loadDeposits()
        ]).then(() => {
            this.loading = false;
        })
    }

    _loadDeposits() {
        return Promise.all([
            this.depositService.getRemoteDeposit('rsvps', 'states', []).then((value) => {
                this.deposits.rsvpStates = value;
                this.updateRsvpStates();
            }),
            this.depositService.getRemoteDeposit('contacts', 'countries', [])
                .then((value) => {
                    this.deposits.countries = _.merge({'': ''}, value);
                }),
            this.depositService.getRemoteDeposit('contacts', 'languages', [])
                .then((value) => {
                    this.deposits.languages = value;
                }),
            this.depositService.getRemoteDeposit('contacts', 'genders', [])
                .then((value) => {
                    this.deposits.genders = value;
                })
        ]);
    }

    _initWatchers() {
        this.scope.$watch(() => {
            return this.rsvp.seatplan_elements;
        }, () => {
            this._updateCurrentPax();
        }, true);

        this.scope.$watch(() => {
            return this.customTimeFieldStates.custom_start_time;
        }, (val) => {
            this.toggleCustomTimeField('custom_start_time');
        }, true);

        this.scope.$watch(() => {
            return this.customTimeFieldStates.custom_end_time;
        }, (val) => {
            this.toggleCustomTimeField('custom_end_time');
        }, true);
    }

    toggleCustomTimeField(field) {
        if (this.customTimeFieldStates[field]) {
            if (Object.keys(this.currentAreaConfigs).length > 0 && !this.rsvp[field] && Object.keys(this.currentAreaConfigs)[0]) {
                if (field === 'custom_start_time') {
                    this.rsvp[field] = new Date(this.currentAreaConfigs[Object.keys(this.currentAreaConfigs)[0]].start);
                } else if (field === 'custom_end_time') {
                    this.rsvp[field] = new Date(this.currentAreaConfigs[Object.keys(this.currentAreaConfigs)[0]].end);
                }
            }
        } else {
            this.rsvp[field] = null;
        }
    }

    _updateCurrentPax() {
        let sum = 0;

        _.forEach(this.rsvp.seatplan_elements, (v) => {
            sum += v.pax;
        });

        this.currentPax = sum;
        if (this.rsvp.pax_planned === 0) {
            this.rsvp.pax_planned = _.clone(this.currentPax);
        }
    }

    _initContactSchema() {
        return this.contactModel.getSchema().then((schema) => {
            this.contactSchema = schema;
        });
    }

    _updateRsvpSeatplanElements() {
        this.rsvp.seatplan_elements = {};
        _.each(this.selected, (currentElement) => {
            this.rsvp.seatplan_elements[currentElement.id] = {
                id: null,
                seatplan_element_id: currentElement.id,
                pax: currentElement.pax,
                bookable_objects: {}
            }
        });
    }

    goToTab(newObject) {
        this.currentSelectedObject = newObject;
    }

    saveRsvp() {
        this.submitting = true;
        let rsvp = this.rsvp;
        if (!rsvp.pax_planned || rsvp.pax_planned === '0') {
            rsvp.pax_planned = this.currentPax;
        }

        if (this.contactType === 1) {
            if (rsvp.contact_id) {
                this.writeRsvpToApi(rsvp);
            } else {
                this.sweetAlert.swal('Kontakt auswählen', 'Es muss ein Kontakt ausgewählt werden', 'error');
                this.submitting = false;
            }
        } else if (this.contactType === 2) {
            if (this.newContact.first_name
                && this.newContact.last_name
                && this.newContact.email) {
                this.newContact.addressbook = 1;

                if (this.newContact.company_name) {
                    this.newContact.business_preferred = true;
                    const fieldsToMoveToBusiness = [
                        'street',
                        'house_number',
                        'email',
                        'zip',
                        'city',
                        'phone',
                        'phone_2',
                        'country'
                    ];

                    angular.forEach(fieldsToMoveToBusiness, (fieldName) => {
                        this.newContact['business_' + fieldName] = this.newContact[fieldName];
                        this.newContact[fieldName] = '';
                    });
                } else {
                    this.newContact.business_preferred = false;
                }

                this.contactModel.post(this.newContact).then((newContact) => {
                    rsvp.contact_id = newContact.id;

                    this.writeRsvpToApi(rsvp);
                });
            } else {
                this.sweetAlert.swal('Kontakt-Daten', 'Folgende Felder sind Pflichtfelder: Vorname, Nachname, Firma, E-Mail', 'error');
                this.submitting = false;
            }
        } else {
            this.sweetAlert.swal('Kontakt benötigt', 'Bitte einen Kontakt erstellen oder auswählen', 'error');
            this.submitting = false;
        }
    }

    writeRsvpToApi(rsvp) {
        if (this._isEmptyBooking() && !this.rsvp.seatplan_area_id) {
            this.sweetAlert.swal('Validation', 'Please select a area', 'warn');
            this.submitting = false;
            return;
        }

        if (_.isUndefined(this.rsvpStates[this.rsvp.status])) {
            this.sweetAlert.swal('Validation', 'Please select a valid status', 'warn');
            this.submitting = false;
            return;
        }

        return this.rsvpModel.setGuestlist(this.guestlist).post(rsvp, {include: 'contact'}).then((responseRsvp) => {
            this.sweetAlert.swal('Buchung erstellt', 'Die Buchung wurde erfolgreich erstellt', 'success');

            this._checkForSendingStatusEmail(responseRsvp, responseRsvp.contact.data, null, responseRsvp.status);
            this.submitting = false;
            this.closeModal();
        }, (error) => {
            if (error.status === 422) {
                if (typeof error.data.errors.seatplan_elements !== 'undefined') {
                    this.sweetAlert.swal('Fehler!', error.data.errors.seatplan_elements[0], 'error');
                    this.submitting = false;
                    return;
                } else {
                    this.sweetAlert.swal('Fehler!', 'Fehler beim speichern. Bitte erneut versuchen', 'error');
                    this.submitting = false;
                    this.dismissModal();
                }
            }
            this.sweetAlert.swal('Fehler!', 'Fehler beim speichern. Bitte erneut versuchen', 'error');
            this.submitting = false;
            this.dismissModal();
        });
    }

    removeCurrentObject() {
        const indexToDelete = this.selected.indexOf(this.currentSelectedObject);

        if (indexToDelete > -1) {
            this.selected.splice(indexToDelete, 1);
        }

        if (this.selected.length !== 0) {
            this.currentSelectedObject = this.selected[0];
        }

        this.updateRsvpStates();
    }

    prepareBlockedElements(selectedElementIds) {
        let out
        if(this.allowElementMultiSelection) {
            out = []
        } else {
            out = _.map(this.bookingInformation, (obj, id) => {
                return parseInt(id);
            });

            _.each(this.blockedElements, (v) => {
                out.push(v);
            });
        }

        _.each(this.blockedElements, (v) => {
            out.push(v);
        });

        return _.filter(out, (value) => (selectedElementIds.indexOf(value) === -1));
    }

    startAddElementModal(singleSelect, selectedElements) {
        let selectedElementIds;

        if (selectedElements) {
            selectedElementIds = selectedElements;
        } else {
            const ids = [];
            _.each(this.rsvp.seatplan_elements, (rse) => {
                ids.push(rse.seatplan_element_id);
            });
            selectedElementIds = ids;
        }

        this.modal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: addElementModalTemplate,
            size: 'xlg',
            controller: 'AddElementModalController',
            resolve: {
                bookingInformation: () => {
                    let bookingInformationForSeatplan = _.cloneDeep(this.bookingInformation);
                    _.each(selectedElementIds, (id) => {
                        if (bookingInformationForSeatplan[id]) {
                            delete bookingInformationForSeatplan[id];
                        }
                    });
                    return bookingInformationForSeatplan;
                },
                showGroupSelection: () => {
                    return true;
                },
                seatplan: () => {
                    return this.seatplan;
                },
                currentGroup: () => {
                    return this.currentGroup;
                },
                hiddenElements: () => {
                    return this.prepareBlockedElements(selectedElementIds);
                },
                requiredPax: () => {
                    return this.rsvp.pax_planned;
                },
                isSingleSelect: () => {
                    return !!singleSelect;
                },
                currentSelectedElementIds: () => {
                    return selectedElementIds;
                },
                allowElementMultiSelection: () => {
                    return this.allowElementMultiSelection
                }
            },
            controllerAs: 'vm'
        }).result.then((selectedInformation) => {
            if (selectedInformation.group !== this.currentGroup) {
                this.currentGroup = selectedInformation.group;
            }
            const newRsvpsSeatplanElements = {};
            this.selected = [];
            _.each(selectedInformation.elements, (selectedElement) => {
                this.selected.push(selectedElement);
                let foundInExisting = false;
                _.each(this.rsvp.seatplan_elements, (existingRse) => {
                    if (existingRse.seatplan_element_id === selectedElement.id) {
                        newRsvpsSeatplanElements[selectedElement.id] = _.cloneDeep(existingRse);
                        foundInExisting = true;
                    }
                });

                if (!foundInExisting) {
                    newRsvpsSeatplanElements[selectedElement.id] = {
                        id: null,
                        element: selectedElement,
                        seatplan_element_id: selectedElement.id,
                        pax: selectedElement.pax
                    };
                }
            });

            this.rsvp.seatplan_elements = newRsvpsSeatplanElements;

            if (this.rsvp.seatplan_elements.length > 0) {
                this.goToTab(this.rsvp.seatplan_elements[0]);
            }
        }, () => {

        });
    }

    closeModal() {
        this.modalInstance.close();
    }

    dismissModal() {
        this.modalInstance.dismiss();
    }

    _getGuestlistConfigForSeatplanElements() {
        return new Promise((resolve, reject) => {
            const seatplanElementIds = [];
            _.each(this.rsvp.seatplan_elements, (v) => {
                seatplanElementIds.push(v.seatplan_element_id);
            });

            this.api.post('guestlists/' + this.guestlist.id + '/booking-definitions', {
                elements: seatplanElementIds
            }).then((result) => {
                this.guestlistConfig = result.data;
                this.currentAreaConfigs = this.guestlistConfig.areas;
                resolve();
            });
        });
    }

    onChangeCombination() {
        if (!this.rsvp.guestlist_combination_id) {
            this.currentAreaConfigs = this.guestlistConfig.areas;
        } else {
            for (let i = 0; i < this.guestlistConfig.available_combinations.length; i++) {
                const curCombination = this.guestlistConfig.available_combinations[i];
                if (this.rsvp.guestlist_combination_id === curCombination.id) {
                    this.currentAreaConfigs = curCombination.areas;
                    break;
                }
            }
        }
    }

    getLabelForBookableObjectId(bookableObjectId) {
        for (let i = 0; i < this.guestlistConfig.bookable_objects.length; i++) {
            const curBookableObject = this.guestlistConfig.bookable_objects[i];
            if (bookableObjectId === curBookableObject.id) {
                return curBookableObject.label;
            }
        }
    }

    handleBoChange(newVal) {
        this.rsvp.bookable_objects = newVal;
    }

    handleSeatplanElementBoChange(newVal) {
        this.rsvp.seatplan_elements[this.currentSelectedObject.id].bookable_objects = newVal;
    }

    updateRsvpStates() {
        if (this._isEmptyBooking()) {
            this.showAreaSelector = true;
        } else {
            this.showAreaSelector = false;
        }

        this.rsvpStates = this.deposits.rsvpStates;
    }

    _isEmptyBooking() {
        return this.selected.length === 0;
    }

    _setSettings() {
        this.enableSeatplanElementsBo = _.get(this.user, 'state.company.settings.seatplans.enable_seatplan_elements_bookable_objects', false);
        this.enableMigrateToNewYear = _.get(this.user, 'state.company.settings.rsvps.enable_year_migration', false);
        this.enableStatusEmailFlow = _.get(this.user, 'state.company.settings.seatplans.enable_rsvp_status_email_on_seatplan_status_change', false);
    }

    goToMainTab(newTab) {
        this.currentMainTab = newTab;
    }

    moveBookableObjectsToSeatplanElements() {
        _.each(this.rsvp.seatplan_elements, (seatplanElement) => {
            seatplanElement.bookable_objects = _.cloneDeep(this.rsvp.bookable_objects);
        });
        this.rsvp.bookable_objects = {};
    }

    _checkForSendingStatusEmail(rsvp, contact, oldStatus, newStatus) {
        if (!this.enableStatusEmailFlow
            || oldStatus === newStatus
            || !this.existEmailTemplateForStatus(this.guestlist, newStatus)) {
            return;
        }

        this.alert.animatedAlert(
            this.translate.instant('rsvps.helpers.rsvps-status-email-helper.ask-email-pop-up.title'),
            this.translate.instant('rsvps.helpers.rsvps-status-email-helper.ask-email-pop-up.content', {
                email_status: this.formatEmailType(newStatus),
                contact_full_name: contact.full_name,
                contact_email: contact.preferred_email
            }),
            'attention',
            {
                confirmButtonText: this.translate.instant('rsvps.helpers.rsvps-status-email-helper.ask-email-pop-up.confirm'),
                cancelButtonText: this.translate.instant('rsvps.helpers.rsvps-status-email-helper.ask-email-pop-up.cancel')
            }
        ).then(
            () => {
                return this.api.post(`messages`, this.setupMessage(rsvp, contact, this.getStatusTemplateIdForGuestlist(this.guestlist, newStatus), newStatus))
                    .then(
                        () => {
                            this.alert.success(
                                this.translate.instant('rsvps.helpers.rsvps-status-email-helper.message_sent.title'),
                                this.translate.instant('rsvps.helpers.rsvps-status-email-helper.message_sent.content')
                            );
                        },
                        response => {
                            this.alert.handle(response);
                        }
                    );
            },
            () => {

            })
    }
    setupMessage(rsvp, contact, templateId, status) {
        return {
            type: 'email',
            send_to_override: contact.preferred_email,
            recipient_type: 'rsvp',
            rsvps: {
                filters: [
                    {
                        field: 'id',
                        operator: 'IN',
                        value: [rsvp.id]
                    }
                ],
                count: 1
            },
            templates: {
                filters: [
                    {
                        field: 'id',
                        operator: 'IN',
                        value: [templateId]
                    }
                ],
                count: 1
            },
            attach_ticket: false,
            attach_passbook: false,
            attach_files: true,
            attach_invoice: false
        };
    }

    existEmailTemplateForStatus(guestlist, status) {
        return !_.isNull(this.getStatusTemplateIdForGuestlist(guestlist, status));
    }

    getStatusTemplateIdForGuestlist(guestlist, status) {
        const filteredGuestlistTemplates = _.filter(guestlist.templates, template => (template.status === status));

        if (filteredGuestlistTemplates.length > 0) {
            return _.get(_.first(filteredGuestlistTemplates), 'template_id', null);
        }

        return null;
    }

    formatEmailType(status) {
        let formattedEmailType = status.substring(0, status.length - 2) + 'ation';

        if (status === 'waitlisted' || status === 'requested') {
            formattedEmailType = status.substring(0, status.length - 2);
        } else if (status === 'declined') {
            formattedEmailType = 'decline';
        }

        return formattedEmailType.charAt(0).toUpperCase() + formattedEmailType.slice(1);
    }
}


DoBookingModalController.$inject = [
    'Contact',
    'Rsvp',
    '$scope',
    '$rootScope',
    'guestlist',
    'seatplan',
    'selectedObjects',
    '$uibModalInstance',
    '$uibModal',
    'SweetAlert',
    'currentGroup',
    'bookingInformation',
    'Contacts',
    '$q',
    '$http',
    'blockedElements',
    'Users',
    'Deposit',
    '$injector'
];

/**
 * @ngdoc object
 * @name guestlists.controller:DoBookingModalController
 *
 * @description
 *
 */
angular
    .module('festzelt-os.guestlists')
    .controller('DoBookingModalController', DoBookingModalController);



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/controllers/guestlists/seats/do-booking-modal-controller.js